<template>
  <vuex-table
    :title="$t('core.payment.titles.operation_history')"
    :fields="fields"
    :auto_start="true"
    table_store="core/payments/table"
  >
    <template slot="amount" slot-scope="{ item }">
      <amount :amount="item.amount" />
    </template>
    <template slot="type" slot-scope="{ item }">
      <type :item="item" />
    </template>
    <template slot="state" slot-scope="{ item }">
      <state-badge :value="item.state" />
    </template>
  </vuex-table>
</template>

<script>
  import Amount from '@core/components/payments/payments-amount.vue';
  import Type from '@core/components/payments/payments-type.vue';
  import StateBadge from '@core/components/payments/payments-badge-state';

  export default {
    components: { Amount, Type, StateBadge },
    computed: {
      fields: function () {
        return [
          {
            key: 'created_at',
            label: this.$t('core.payment.field.date'),
            sortable: true,
            class: 'table-created_at'
          },
          {
            key: 'amount',
            label: this.$t('core.payment.field.amount'),
            sortable: true          },
          {
            key: 'type',
            label: this.$t('core.payment.field.type'),
            class: 'w-25'
          },
          {
            key: 'system',
            label: this.$t('core.payment.field.system'),
            class: 'w-25',
            formatter: (value) => (value ? this.$t(`core.payment.payment_system.${value}`) : '')
          },
          {
            key: 'state',
            label: this.$t('core.payment.field.status'),
            sortable: true,
            class: 'w-25'
          }
        ];
      }
    }
  };
</script>